import { render, staticRenderFns } from "./Job.vue?vue&type=template&id=64daab8a&scoped=true&"
import script from "./Job.vue?vue&type=script&lang=js&"
export * from "./Job.vue?vue&type=script&lang=js&"
import style0 from "./Job.vue?vue&type=style&index=0&id=64daab8a&prod&lang=sass&scoped=true&"
import style1 from "./Job.vue?vue&type=style&index=1&id=64daab8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64daab8a",
  null
  
)

export default component.exports